import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../css/about.css";
// import WhatsAppFloat from "../components/whatsapp";
import Footer from "../components/footer";
import aboutUs from "../images/aboutus2.jpg";

import cake1 from "../images/cake1.jpeg";
import cake2 from "../images/cake2.jpeg";
import cake3 from "../images/cake3.jpeg";
import cake4 from "../images/cake4.jpeg";
import cake5 from "../images/cake5.jpeg";
import cake6 from "../images/cake6.jpeg";
import cake7 from "../images/cake7.jpeg";
import cake8 from "../images/cake8.jpeg";
import cake9 from "../images/cake9.jpeg";
import cake10 from "../images/cake10.jpeg";
import cake11 from "../images/cake11.jpeg";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderImages = [
    { src: cake1, alt: "Delicious chocolate cake" },
    { src: cake2, alt: "Tiered wedding cake" },
    { src: cake3, alt: "Birthday cake with sprinkles" },
    { src: cake4, alt: "Assorted cupcakes" },
    { src: cake5, alt: "Heart-shaped cake with frosting" },
    { src: cake6, alt: "Colorful birthday cake with candles" },
    { src: cake7, alt: "Elegant wedding cake with floral decorations" },
    { src: cake8, alt: "Chocolate cake with ganache drizzle" },
    { src: cake9, alt: "Vanilla cake with buttercream frosting" },
    { src: cake10, alt: "Assorted mini cakes on display" },
    { src: cake11, alt: "Birthday cake with fresh fruit toppings" },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === sliderImages.length - 1 ? 0 : prev + 1,
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? sliderImages.length - 1 : prev - 1,
    );
  };

  // Auto-play functionality
  useEffect(() => {
    const slideInterval = setInterval(nextSlide, 4000);
    return () => clearInterval(slideInterval);
  }, [currentSlide]);

  // Calculate left and right indices for the side images
  const prevIndex =
    currentSlide === 0 ? sliderImages.length - 1 : currentSlide - 1;
  const nextIndex =
    currentSlide === sliderImages.length - 1 ? 0 : currentSlide + 1;

  return (
    <div className="about-wrapper">
      <Helmet>
        <title>Lovely Cakes | About Us</title>
        <meta
          name="description"
          content="Learn the story behind Lovely Cakes. We bake delicious, honest cakes from scratch for birthdays, anniversaries, and everyday moments in Walsall."
        />
        <meta
          name="keywords"
          content="bakery, walsall, fresh cakes, custom cakes, Lovely Cakes about, birthday cakes, walsall"
        />
      </Helmet>

      {/* Internal Styles for 3-Image Carousel & Animations */}
      <style>{`
        .carousel-stage {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 500px;
          overflow: hidden;
          width: 100%;
          background: #fdfdfd;
          padding: 20px 0;
        }
        
        .slide-img {
          position: absolute;
          border-radius: 12px;
          object-fit: cover;
          aspect-ratio: 3 / 4;
          cursor: pointer;
        }

        /* Gentle Animations for a smooth swap */
        @keyframes subtleFadeCenter {
          0% { opacity: 0.7; transform: translateX(-50%) scale(0.97); }
          100% { opacity: 1; transform: translateX(-50%) scale(1); }
        }
        
        @keyframes subtleFadeSide {
          0% { opacity: 0.1; }
          100% { opacity: 0.4; }
        }

        .slide-left {
          left: 5%;
          height: 65%;
          z-index: 1;
          transform: scale(0.9);
          animation: subtleFadeSide 0.5s ease-out forwards;
        }
        
        .slide-center {
          left: 50%;
          height: 90%;
          z-index: 5;
          box-shadow: 0 15px 35px rgba(0,0,0,0.15);
          border-radius: 16px;
          cursor: default;
          animation: subtleFadeCenter 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
        }
        
        .slide-right {
          right: 5%;
          height: 65%;
          z-index: 1;
          transform: scale(0.9);
          animation: subtleFadeSide 0.5s ease-out forwards;
        }

        .control-btn {
          background: transparent;
          color: #333;
          border: none;
          padding: 8px 12px;
          cursor: pointer;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.2s ease, color 0.2s ease;
        }
        
        .control-btn:hover {
          color: #000;
          transform: scale(1.15);
        }
        
        .dot-indicator {
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        }

        /* Mobile Adjustments */
        @media (max-width: 600px) {
          .carousel-stage {
            height: 400px;
          }
          .slide-left { left: -15%; opacity: 0.2; }
          .slide-right { right: -15%; opacity: 0.2; }
          .slide-center { height: 85%; }
        }
      `}</style>

      <section className="about-hero">
        <img
          src={aboutUs}
          alt="Freshly baked artisan cakes on display at Lovely Cakes bakery"
          className="hero-image"
          loading="lazy"
        />
        <div className="hero-title-overlay">
          <h1 className="about-title">Lovely Cakes</h1>
        </div>
      </section>

      <section className="about-content">
        <div className="text-column">
          <h2>Honest Baking in Walsall</h2>
          <p>
            Welcome to Lovely Cakes. We started with a very simple idea: to bake
            delicious, comforting cakes that bring people together across{" "}
            <strong>Walsall</strong>. No fuss, no overly complicated
            recipes—just honest baking using the same real, simple ingredients
            you would find in your own kitchen at home.
          </p>
          <p>
            For us, baking isn't about showing off; it's about sharing something
            good. We put a lot of love and care into every single sponge,
            filling, and frosting we make, ensuring that every bite tastes just
            right.
          </p>
        </div>

        <div className="text-column">
          <h2>Cakes for all occasions</h2>
          <p>
            Whether you are celebrating a milestone <strong>birthday</strong>, a
            quiet
            <strong> anniversary</strong>, or just treating yourself for making
            it through a busy week, we believe there is always a good reason for
            a fresh cake.
          </p>
          <p>
            We are incredibly grateful that you choose to include our local
            bakes in your special moments. Thank you for supporting our little
            bakery and letting us do what we love every day.
          </p>
        </div>
      </section>

      {/* --- Our Work Slideshow Section --- */}
      <section
        className="our-work-section"
        style={{
          textAlign: "center",
          padding: "60px 20px",
          backgroundColor: "#fcfaf8",
        }}
      >
        <h2 style={{ marginBottom: "10px", fontSize: "2rem", color: "#333" }}>
          Our Work
        </h2>
        <p style={{ color: "#666", marginBottom: "40px" }}>
          A peek at some of the cakes we've lovingly baked for our customers.
        </p>

        <div
          className="slideshow-container"
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            borderRadius: "16px",
            boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Images Stage */}
          <div className="carousel-stage">
            {/* Left/Previous Image (Added key to trigger animation on swap) */}
            <img
              key={`left-${prevIndex}`}
              className="slide-img slide-left"
              src={sliderImages[prevIndex].src}
              alt={sliderImages[prevIndex].alt}
              onClick={prevSlide}
            />

            {/* Center/Current Image (Key forces animation trigger) */}
            <img
              key={`center-${currentSlide}`}
              className="slide-img slide-center"
              src={sliderImages[currentSlide].src}
              alt={sliderImages[currentSlide].alt}
            />

            {/* Right/Next Image (Added key to trigger animation on swap) */}
            <img
              key={`right-${nextIndex}`}
              className="slide-img slide-right"
              src={sliderImages[nextIndex].src}
              alt={sliderImages[nextIndex].alt}
              onClick={nextSlide}
            />
          </div>

          {/* Control Bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 24px",
              borderTop: "1px solid #f0f0f0",
              backgroundColor: "#fff",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            {/* Previous Button */}
            <button
              className="control-btn"
              onClick={prevSlide}
              aria-label="Previous image"
            >
              &#10094;
            </button>

            {/* Dots Indicator */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "8px",
                maxWidth: "60%",
              }}
            >
              {sliderImages.map((_, index) => (
                <span
                  key={index}
                  className="dot-indicator"
                  onClick={() => setCurrentSlide(index)}
                  style={{
                    height: "8px",
                    width: currentSlide === index ? "24px" : "8px",
                    borderRadius: "8px",
                    display: "inline-block",
                    cursor: "pointer",
                    backgroundColor:
                      currentSlide === index ? "#333" : "#d1d1d1",
                  }}
                ></span>
              ))}
            </div>

            {/* Next Button */}
            <button
              className="control-btn"
              onClick={nextSlide}
              aria-label="Next image"
            >
              &#10095;
            </button>
          </div>
        </div>
      </section>

      {/* <WhatsAppFloat /> */}
      <Footer />
    </div>
  );
};

export default About;
